export const PUMP_LINK =
  "https://pump.fun/zNGnf8URkg8wqUYMY6xYB5Roj1pwAb6iq7fuD8cpump";
export const TWITTER_LINK = "";
export const TELEGRAM_LINK = "";
